module.exports = __webpack_public_path__ + "static/media/shampoo.270aae8d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bonus/shampoo/shampoo.pdf
// module id = 65
// module chunks = 0